import {
  CompanyAgentDataInterface,
  ContainerInterface,
  FormAttemptDetailsInterface,
  FormAttemptListItemInterface,
  FormAttemptsListQueryInterface,
  IPaginatorData,
  RejectFormAttemptInterface,
  SetDataRecordRequestInterface,
} from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { api } from '../api';

export const getLegalFormStructure: (formAttemptId: number) => Promise<FormAttemptDetailsInterface> = (
  formAttemptId: number
): Promise<FormAttemptDetailsInterface> => api.get(
  `legal-forms/structure/${formAttemptId}`
);

export const addLegalFormStructureGroup: (formAttemptId: number, groupPath: string) => Promise<ContainerInterface> = (
  formAttemptId: number, groupPath: string
): Promise<ContainerInterface> => api.post(
  `legal-forms/structure/${formAttemptId}/${groupPath}`
);

export const removeLegalFormStructureGroup: (formAttemptId: number, groupPath: string) => Promise<void> = (
  formAttemptId: number, groupPath: string
): Promise<void> => api.delete(
  `legal-forms/structure/${formAttemptId}/${groupPath}`
);

export const setLegalFormDataRecord: (formAttemptId: number, recordData: SetDataRecordRequestInterface) => Promise<void> = (
  formAttemptId: number, recordData: SetDataRecordRequestInterface
): Promise<void> => api.post(
  `legal-forms/data/${formAttemptId}`, recordData
);

export const approveFormAttempt: (formAttemptId: number) => Promise<void> = (
  formAttemptId: number
): Promise<void> => api.post(`legal-forms/attempt/${formAttemptId}/approve`);

export const rejectFormAttempt: (formAttemptId: number, data: RejectFormAttemptInterface) => Promise<void> = (
  formAttemptId: number, data: RejectFormAttemptInterface
): Promise<void> => api.post(
  `legal-forms/attempt/${formAttemptId}/reject`, data
);

export const finishFormAttemptAndRequestVerification: (formAttemptId: number) => Promise<void> = (
  formAttemptId: number
): Promise<void> => api.post(
  `legal-forms/attempt/${formAttemptId}/request-verification`
);

export const initFormAttemptVerification: (formAttemptId: number) => Promise<void> = (
  formAttemptId: number
): Promise<void> => api.post(
  `legal-forms/attempt/${formAttemptId}/init-verification`
);

// TODO: add CompanyAgentsQueryInterface when type will be available on global
export const getLegalFormsCompanyAgents: (formAttemptId: number) => Promise<CompanyAgentDataInterface[]> = (
  formAttemptId: number
): Promise<CompanyAgentDataInterface[]> => api.get(
  `legal-forms/custom-data/company-agents?${stringify({ formAttemptId }, { skipEmptyString: true })}`
);

export const getLegalFormAttemptList: (params: FormAttemptsListQueryInterface) => Promise<IPaginatorData<FormAttemptListItemInterface>>
  = (params: FormAttemptsListQueryInterface): Promise<IPaginatorData<FormAttemptListItemInterface>> => api.get(
    `/legal-forms/attempts?${stringify(params, { skipEmptyString: true })}`
  );
